module.exports = __webpack_public_path__ + "img/logo.ce7c298d.svg";